import { TableColumn } from 'types/types'
import { Button } from 'components'

export interface AdminEndpoint {
  id: string
  url: string
  parameters?: string
  onExecute: () => void
}

export const adminTableColumns = (): TableColumn[] => [
  {
    id: 'url',
    label: 'Endpoint URL',
    minWidth: 300,
  },
  {
    id: 'parameters',
    label: 'Parameters',
    minWidth: 200,
  },
  {
    id: 'actions',
    label: '',
    minWidth: 100,
    align: 'right',
    format: (_: unknown, row: AdminEndpoint) => (
      <Button size="small" onClick={row.onExecute}>
        Execute
      </Button>
    ),
  },
]
